import { Component } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { DebounceClickDirective } from '@uzurv/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { AbstractPaymentAccountForm } from '../abstract-payment-account-form';

@Component({
  selector: 'app-organization-rider-payment-account-form',
  templateUrl: './organization-rider-payment-account-form.component.html',
  styleUrls: ['./organization-rider-payment-account-form.component.scss'],
  standalone: true,
  imports: [
    CreditCardDirectivesModule,
    DebounceClickDirective,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule
  ]
})
export class OrganizationRiderPaymentAccountFormComponent extends AbstractPaymentAccountForm {}
